import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { KartableService } from 'src/app/Service/Kartable/Kartable.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-KartableBarchasb',
  templateUrl: './KartableBarchasb.component.html',
  styleUrls: ['./KartableBarchasb.component.css']
})
export class KartableBarchasbComponent implements OnInit {

  page: number = 0;
  Procssing: boolean = false;
  InProccessing: boolean = false;
  Filter_Letter_Id: string = ""
  Filter_Customer: string = ""

  modalRef_operation: any;

  DataList_Certificate: Array<any> = []
  constructor(
    private Kartable_Service: KartableService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Nav_Service.CheckValidPage(2235).subscribe(
      data => {
        this.ReadData_Certificate()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Certificate() {
    this.Procssing = true
    this.Kartable_Service.GetBarchasb(Number(this.Filter_Letter_Id),this.Filter_Customer).subscribe(
      data => {
        this.DataList_Certificate = data
        this.Procssing = false

      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  ConfirmList() {
  this.modalRef_operation.hide()
   this.Procssing = true
    this.Kartable_Service.ConfirmBarchasb(this.ids).subscribe(
      data => {
        this.Procssing = false
        this.ids = []
        this.Alertify_Service.SuccessMessage("تایید شد")
        this.ReadData_Certificate()
      }
    )
  }


  openModal(template: TemplateRef<any>) {
    this.modalRef_operation = this.modalService.show(template);
  }


  //#region  CheckAll

  ids: Array<number> = []

  Check_All: boolean = false
  onChange_CheckAll() {
    this.Check_All = !this.Check_All
    if (this.Check_All) {
      for (let item of this.DataList_Certificate) {
        item.selected = true
      }
    }
    else {
      for (let item of this.DataList_Certificate) {
        item.selected = false
      }
    }

    this.set_Selected_Subscription()
  }

  onChange_CheckItem(item: any) {
    item.selected = !item.selected
    if (item.selected == false) {
      this.Check_All = false
    }

    this.set_Selected_Subscription()
  }

  set_Selected_Subscription() {
    this.ids = []
    for (let item of this.DataList_Certificate) {
      if (item.selected) {
        this.ids.push(Number(item.id))
      }
    }
  }

  //#endregion

}
